export type ThemeId = 'normal' | 'dark' | 'high-contrast';

export interface ThemeProfile {
  id: ThemeId;
  label: string;
  description: string;
  tokens: {
    background: string;
    surface: string;
    surfaceMuted: string;
    text: string;
    textSecondary: string;
    textInverse: string;
    primary: string;
    primaryContrast: string;
    secondary: string;
    secondaryContrast: string;
    accent: string;
  };
  assets: {
    logo: string;
    logoAlt: string;
  };
}

export const themeProfiles: Record<ThemeId, ThemeProfile> = {
  normal: {
    id: 'normal',
    label: 'Light',
    description: 'Bright neutral mode tuned for daylight viewing.',
    tokens: {
      background: '#f9f9f9',
      surface: '#ffffff',
      surfaceMuted: '#f0f0f0',
      text: '#1b1b1d',
      textSecondary: '#403f41',
      textInverse: '#f9f9f9',
      primary: '#403f41',
      primaryContrast: '#f9f9f9',
      secondary: '#f69898',
      secondaryContrast: '#1b1b1d',
      accent: '#f69898',
    },
    assets: {
      logo: '/assets/logo_color.svg',
      logoAlt: '/assets/logo_bw.svg',
    },
  },
  dark: {
    id: 'dark',
    label: 'Night',
    description: 'Low-glare palette optimized for dim environments.',
    tokens: {
      background: '#121214',
      surface: '#1b1b1d',
      surfaceMuted: '#252527',
      text: '#f1f1f2',
      textSecondary: '#d0d0d4',
      textInverse: '#1b1b1d',
      primary: '#f69898',
      primaryContrast: '#1b1b1d',
      secondary: '#c4c2ff',
      secondaryContrast: '#121214',
      accent: '#ffd166',
    },
    assets: {
      logo: '/assets/logo_color.svg',
      logoAlt: '/assets/logo_bw.svg',
    },
  },
  'high-contrast': {
    id: 'high-contrast',
    label: 'High Contrast',
    description: 'Accessibility-first palette exceeding WCAG AAA contrast ratios.',
    tokens: {
      background: '#ffffff',
      surface: '#ffffff',
      surfaceMuted: '#f2f2f2',
      text: '#000000',
      textSecondary: '#111111',
      textInverse: '#ffffff',
      primary: '#000000',
      primaryContrast: '#ffffff',
      secondary: '#ffd700',
      secondaryContrast: '#000000',
      accent: '#ff4d00',
    },
    assets: {
      logo: '/assets/logo_bw.svg',
      logoAlt: '/assets/logo_color.svg',
    },
  },
};

export const themeOrder: ThemeId[] = ['normal', 'dark', 'high-contrast'];
